import * as types from './types';

export const resetCandidateProfileResetProfileState = () => ({
  type: types.CANDIDATE_PROFILE_RESET_PROFILE_STATE
});

export const setCandidateProfileBiographicalInformation = biographicalInformation => ({
  type: types.CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION,
  biographicalInformation
});

export const setCandidateProfileSectionsStatesLoadingLoader = isLoading => ({
  type: types.CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES_LOADING_LOADER,
  isLoading
});

export const setCandidateProfileLoadingLoader = isLoading => ({
  type: types.CANDIDATE_PROFILE_SET_LOADING_LOADER,
  isLoading
});

export const setCandidateProfileSubmittingLoader = isSubmitting => ({
  type: types.CANDIDATE_PROFILE_SET_SUBMITTING_LOADER,
  isSubmitting
});

export const fetchCandidateProfileBiographicalInformation = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_BIOGRAPHICAL_INFORMATION
});

export const submitCandidateProfileBiographicalInformation = (
  biographicalInformation,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_BIOGRAPHICAL_INFORMATION,
  biographicalInformation,
  onUpdated
});

export const setCandidateProfileSectionsStates = profileSectionsStates => ({
  type: types.CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES,
  profileSectionsStates
});

export const fetchCandidateProfileSectionsStates = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_PROFILE_SECTIONS_STATES
});

export const setCandidateProfileHousingPreferences = housingPreferences => ({
  type: types.CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES,
  housingPreferences
});

export const fetchCandidateProfileHousingPreferences = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_HOUSING_PREFERENCES
});

export const submitCandidateProfileHousingPreferences = (
  housingPreferences,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_HOUSING_PREFERENCES,
  housingPreferences,
  onUpdated
});

export const setCandidateProfileHealth = health => ({
  type: types.CANDIDATE_PROFILE_SET_HEALTH,
  health
});

export const fetchCandidateProfileHealth = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_HEALTH
});

export const submitCandidateProfileHealth = (health, onUpdated) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_HEALTH,
  health,
  onUpdated
});

export const setCandidateProfileSportActivities = sportActivities => ({
  type: types.CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES,
  sportActivities
});

export const fetchCandidateProfileSportActivities = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_SPORT_ACTIVITIES
});

export const submitCandidateProfileSportActivities = (
  sportActivities,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_SPORT_ACTIVITIES,
  sportActivities,
  onUpdated
});

export const setCandidateProfileLanguages = languages => ({
  type: types.CANDIDATE_PROFILE_SET_LANGUAGES,
  languages
});

export const fetchCandidateProfileLanguages = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_LANGUAGES
});

export const submitCandidateProfileLanguages = (languages, onUpdated) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_LANGUAGES,
  languages,
  onUpdated
});

export const submitCandidateProfilePersonal = (personal, onUpdated) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_PERSONAL,
  personal,
  onUpdated
});

export const fetchCandidateProfilePersonal = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_PERSONAL
});

export const setCandidateProfilePersonal = personal => ({
  type: types.CANDIDATE_PROFILE_SET_PERSONAL,
  personal
});

export const setCandidateProfileSecondarySchools = secondarySchools => ({
  type: types.CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS,
  secondarySchools
});

export const fetchCandidateProfileSecondarySchools = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_SECONDARY_SCHOOLS
});

export const submitCandidateProfileSecondarySchools = (
  secondarySchools,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_SECONDARY_SCHOOLS,
  secondarySchools,
  onUpdated
});

export const submitCandidateProfileTeachingExperience = (
  teachingExperience,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_TEACHING_EXPERIENCE,
  teachingExperience,
  onUpdated
});

export const fetchCandidateProfileTeachingExperience = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_TEACHING_EXPERIENCE
});

export const setCandidateProfileTeachingExperience = teachingExperience => ({
  type: types.CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE,
  teachingExperience
});

export const submitCandidateProfileContactInformation = (
  contactInformation,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_CONTACT_INFORMATION,
  contactInformation,
  onUpdated
});

export const fetchCandidateProfileContactInformation = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_CONTACT_INFORMATION
});

export const setCandidateProfileContactInformation = contactInformation => ({
  type: types.CANDIDATE_PROFILE_SET_CONTACT_INFORMATION,
  contactInformation
});

export const setCandidateProfileUniversitiesColleges = universitiesColleges => ({
  type: types.CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES,
  universitiesColleges
});

export const fetchCandidateProfileUniversitiesColleges = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_UNIVERSITIES_COLLEGES
});

export const submitCandidateProfileUniversitiesColleges = (
  universitiesColleges,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_UNIVERSITIES_COLLEGES,
  universitiesColleges,
  onUpdated
});

export const setCandidateProfileTeachingCredentials = teachingCredentials => ({
  type: types.CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS,
  teachingCredentials
});

export const fetchCandidateProfileTeachingCredentials = () => ({
  type: types.CANDIDATE_PROFILE_FETCH_TEACHING_CREDENTIALS
});

export const submitCandidateProfileTeachingCredentials = (
  teachingCredentials,
  onUpdated
) => ({
  type: types.CANDIDATE_PROFILE_SUBMIT_TEACHING_CREDENTIALS,
  teachingCredentials,
  onUpdated
});

export const getAllCandidateProfileSections = () => ({
  type: types.CANDIDATE_PROFILE_GET_ALL_SECTIONS
});


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-profile/index.js